import { generateBaseQueryKeysList } from '@/queries/utils';

export const HOME_LOCATION_KEYS = {
  main: 'homelocation',
};

export const homeLocationsQueryKeys = generateBaseQueryKeysList(HOME_LOCATION_KEYS.main);
